import { useReactiveVar } from '@apollo/client';
import { Form } from 'antd';
import { visibleDrawerVar } from 'api/cache';
import UpdateCreateModal from 'containers/UpdateCreateModal';
import { useAddHost, useEditHost } from 'operations/mutations/host/mutateHost';
import React from 'react';
import { setError } from 'utils/other';
import HostFormContent from './HostFormContent';

const HostForm = () => {
  const { mutate: editHost } = useEditHost();
  const visibleDrawer = useReactiveVar(visibleDrawerVar);

  const { mutate: createHost } = useAddHost();

  const [form] = Form.useForm();

  const onSave = async () => {
    try {
      const params = await form.validateFields();
      const _image = params.image;

      await editHost({
        variables: {
          input: {
            ...params,
            id: visibleDrawer.record.id,
            image: _image?.file?.response?.Data || _image
          }
        }
      });

      visibleDrawerVar({ visible: false, record: null });
    } catch (e) {
      setError(form, e);
    }
  };

  const onCreate = async () => {
    try {
      const params = await form.validateFields();
      const _image = params.image;

      await createHost({
        variables: {
          addHostInput: {
            ...params,
            image: _image?.file?.response?.Data || _image
          }
        }
      });
      form.resetFields();
      visibleDrawerVar(false);
    } catch (error) {}
  };

  return (
    <UpdateCreateModal
      title={visibleDrawer.record ? 'Chỉnh sửa host' : 'Tạo host'}
      onOk={visibleDrawer.record ? onSave : onCreate}
      onClose={() => {
        form.resetFields();
        visibleDrawerVar(false);
      }}
      visible={visibleDrawer.visible}
      isUpdate={!!visibleDrawer.record}
      destroyOnClose
    >
      <HostFormContent
        form={form}
        onSubmit={visibleDrawer.record ? onSave : onCreate}
      />
    </UpdateCreateModal>
  );
};

export default HostForm;
